/*
Copyright MITSUBISHI Elec.
*/

/**
 * 日付設定カレンダ拡張機能。
 *
 * @module BlenderCalendar
 * @class BlenderCalendar
 */

/**
 * メソッドのオーバーライドを行う。
 * @param object 対象オブジェクト
 * @param methodName メソッド名
 * @param callback オーバーライド後の関数
 */
function override(object, methodName, callback) {
	object[methodName] = callback(object[methodName]);
}

/**
 * メソッドオーバーライド時、前に挿入する処理部を指定する。
 * @param extraBehavior 追加処理部分の関数
 */
function after(extraBehavior) {
	return function(original) {
		return function() {
			var returnValue = original.apply(this, arguments);
			extraBehavior.apply(this, arguments);
			return returnValue;
		}
	}
}

/**
 * メソッドオーバーライド時、後に挿入する処理部を指定する。
 * @param extraBehavior 追加処理部分の関数
 */
function before(extraBehavior) {
	return function(original) {
		return function() {
			extraBehavior.apply(this, arguments);
			return original.apply(this, arguments);
		}
	}
}

/**
 * メソッドオーバーライド時の組合せ処理（元処理の結果を補正）を指定する。
 * @param extraBehavior 追加処理部分の関数
 */
function compose(extraBehavior) {
	return function(original) {
		return function() {
			return extraBehavior.call(this, original.apply(this, arguments))
		}
	}
}

/**
 * メソッドオーバーライド時の前処理（元処理の前に引数を補正）を指定する。
 * @param extraBehavior 追加処理部分の関数（補正した引数を返す）
 */
function preprocess(extraBehavior) {
	return function(original) {
		return function() {
			return original.apply(this, extraBehavior.apply(this, arguments));
		}
	}
}

/**
 * メソッドオーバーライド時の条件処理（元処理の前に実行orスキップを判断）を指定する。
 * @param extraBehavior 追加処理部分の関数（実行ならtrue、スキップならfalseを返す）
 */
function when(extraBehavior) {
	return function(original) {
		return function() {
			return (extraBehavior.apply(this, arguments)) ?
					original.apply(this, arguments) : null;
		}
	}
}


/** 年のラベル */
BlenderCalendarObject.LABEL_YEAR = "年";

/** [OK]ボタンのラベル */
BlenderCalendarObject.LABEL_OK = "OK";

/** [...]ボタンのラベル */
BlenderCalendarObject.LABEL_EXPAND = "...";

/**
 * dhtmlXCalendarObject拡張版カレンダパッチ処理クラス。
 *
 * @class BlenderCalendarObject
 */
function BlenderCalendarObject() {
}

// TODO dhtmlXCalendarObjectをBlenderCalendarObjectに完全置換するか保留。現状はメソッドパッチ方式。
//	/**
//	 * dhtmlXCalendarObject拡張版カレンダ
//	 * @class BlenderCalendarObject
//	 * @param inps inputs
//	 * @param skin
//	 * @param params
//	 */
//	function BlenderCalendarObject(inps, skin, params) {
//
//		dhtmlXCalendarObject.call(this, inps, skin);
//
//		// 機能拡張を行う
//		BlenderCalendarObject.extendFunction(this, params);
//	}
//
//	// Extends
//	BlenderCalendarObject.inherit(dhtmlXCalendarObject);


/**
 * 機能拡張を行う。
 *
 * @method extendFunction
 * @param calendar dhtmlxCalendarオブジェクト
 * @param params オプション指定パラメータ連想配列({
 * 							swapYearMonthPos: 年、月表示位置入替(true|false),
 * 							useOkButton: [OK]ボタン表示(true|false),
 * 							useFlexMinutesInterval: 分の拡張モード追加(true|false)})
 */
BlenderCalendarObject.extendFunction = function(calendar, params) {

	// ■DHTMLX3.x不具合対応
	// _showSelector()処理オーバーライド（前処理追加）
	override(calendar, "_showSelector", before(function(a,b,c,d,e) {
		// 不具合1：分を編集中に、年、月、時の編集に移ると、以降、分セレクターが崩れるため、毎回初期化
		if (this._sel && !this._sel.ta && a != "minutes") {
			this._unloadSelector("minutes");
		}
		if (this._sel && !this._sel.ta && a != "hours") {
			this._unloadSelector("hours");
		}
		// 不具合2：分を編集中に、年、月、時の編集に移ると、分の赤下線が残るため、毎回消去
		if (a != "minutes") {
			$(this.contTime.firstChild.firstChild.childNodes[3]).children().removeClass("dhtmlxcalendar_selected_date");
		}
	}));
	// _drawMonth()処理オーバーライド（条件処理追加）
	// 不具合3：選択可能範囲を超えて年を選択可能な点を改善
	override(calendar, "_drawMonth", when(BlenderCalendarObject.patchDrawMonth));
	// _updateYearsList()処理オーバーライド（後処理追加）
	// 不具合3：選択可能範囲を超えて年を選択可能な点を改善
	override(calendar, "_updateYearsList", after(BlenderCalendarObject.patchUpdateYearsList));

	// ■showTime機能(時刻編集モード)基本対応
	// showTime()処理オーバーライド（前処理追加）
	override(calendar, "showTime", before(function(d) {
		// 時刻表示あり用の背景表示のためCSSクラス設定
		$(this.base).addClass("hastime");
	}));
	// hideTime()処理オーバーライド（前処理追加）
	override(calendar, "hideTime", before(function(d) {
		// 時刻表示なし用の背景表示のためCSSクラス設定
		$(this.base).removeClass("hastime");
	}));
	if (typeof (BlenderCalendar) != "undefined") {
		// BlenderCalendarにshowTime()処理追加
		if (BlenderCalendar.prototype.showTime == null) {
			BlenderCalendar.prototype.showTime = function(minutesInterval) {
				if (minutesInterval == null) {
					minutesInterval = 5;
				} //else if (
				minutesInterval = minutesInterval? parseInt(minutesInterval, 10) : 5;
				if (!(minutesInterval == 1 || minutesInterval == 5
						|| minutesInterval == 10 || minutesInterval == 15)) {
					return;
				}

				// 時刻ありの書式をセット
				this.dt_mask = BlenderCalendar.DT_MASK_SHOWTIME;
				this.in_mask = BlenderCalendar.IN_MASK_SHOWTIME;
				this.calendar.setDateFormat("%Y/%m/%d %H:%i");
				if ( BlenderCalendarSettings.KEEP_INVALID_DATE ) {
					this.textMaxLength = BlenderCalendar.SHOWTIME_TEXT_MAX_LENGTH;
					this.textFld.attr("maxlength", this.textMaxLength);
				}
				// dhtmlXCalendarを時刻表示ありに変更
				this.calendar.setMinutesInterval(minutesInterval);
				this.calendar.showTime();
			}
		}
		// BlenderCalendarにhideTime()処理追加
		if (BlenderCalendar.prototype.hideTime == null) {
			BlenderCalendar.prototype.hideTime = function() {
				// 時刻なしの書式をセット
				this.dt_mask = BlenderCalendar.DT_MASK;
				this.in_mask = BlenderCalendar.IN_MASK;
				this.calendar.setDateFormat("%Y/%m/%d");
				if ( BlenderCalendarSettings.KEEP_INVALID_DATE ) {
					this.textMaxLength = BlenderCalendar.DEFAULT_TEXT_MAX_LENGTH;
					this.textFld.attr("maxlength", this.textMaxLength);
				}
				// dhtmlXCalendarを時刻表示なしに変更
				this.calendar.hideTime();
			}
		}
	}

	// 拡張機能オプション指定パラメータを判定し、calendarオブジェクトにフラグとしてセット
	// (1) swapYearMonthPos: true
	// 　　カレンダーヘッダーの年、月表示位置を入替
	// 　　※DHTMLX 4以降ではlanguage定義で書式を制御可能であり、本特殊処理は不要となる。
	// (2) useOkButton: true
	// 　　時刻編集時、日付クリックで閉じないよう変更し、[OK]ボタンを追加
	// (3) useFlexMinutesInterval: true
	// 　　時刻編集時、5分単位モードから、[...]ボタンで1分単位モードに変更
	// (4) useSelectionStyle: true
	// 　　年月時分のセレクタを<select>スタイルに変更
	if (params == null) {
		params = {};
	}
	calendar.swapYearMonthPos = (params["swapYearMonthPos"] != false);
	calendar.useOkButton = (params["useOkButton"] != false);
	calendar.useFlexMinutesInterval = (params["useFlexMinutesInterval"] != false);
	calendar.useSelectionStyle = (params && params["useSelectionStyle"]);

	// ■年、月表示位置入替（swapYearMonthPos）対応
	BlenderCalendarObject.extendSwapYearMonthPos(calendar);

	// ■[OK]ボタン表示（useOkButton）対応
	BlenderCalendarObject.extendUseOkButton(calendar);

	// ■分の拡張モード追加（useFlexMinutesInterval）対応
	BlenderCalendarObject.extendUseFlexMinutesInterval(calendar);

	// ■年月時分のセレクタを<select>に変更
	BlenderCalendarObject.extendSelectionStyle(calendar);
}

/**
 * 左右矢印ボタンの機能補正を行う。
 * @method patchDrawMonth
 * @param a 選択中の年月のDate
 */
BlenderCalendarObject.patchDrawMonth = function(a) {
 	if (a instanceof Date && !isNaN(a.getFullYear()) && this._rangeType == "in") {
		var minYear = null, maxYear = null;
		if (this._rangeFrom)	minYear = new Date(this._rangeFrom).getFullYear();
		if (this._rangeTo)		maxYear = new Date(this._rangeTo).getFullYear();

		// 上限、下限を超えた日付に変更しようとしている場合、取り消す
		if ((minYear && a.getFullYear() < minYear) || (maxYear && a.getFullYear() > maxYear)) {
			return false;
		}

		// 下限の月かどうかで、左矢印の活性／非活性を制御
		if (minYear) {
			if (new Date(a.getFullYear(), a.getMonth() - 1, 1).getFullYear() < minYear) {
				$(this.contMonth.firstChild.firstChild.firstChild)
					.removeClass("dhtmlxcalendar_month_arrow_left_hover")
					.addClass("dhtmlxcalendar_month_arrow_left")
					.addClass("cal_arrow_disabled")
					.hover(
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left cal_arrow_disabled"},0,this);},
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left cal_arrow_disabled"},0,this);}
					);
			} else {
				$(this.contMonth.firstChild.firstChild.firstChild)
					.removeClass("cal_arrow_disabled")
					.hover(
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left_hover"},0,this);},
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left"},0,this);}
					);
			}
		}
		// 上限の月かどうかで、右矢印の活性／非活性を制御
		if (maxYear) {
			if (new Date(a.getFullYear(), a.getMonth() + 1, 1).getFullYear() > maxYear) {
				$(this.contMonth.firstChild.firstChild.lastChild)
					.removeClass("dhtmlxcalendar_month_arrow_right_hover")
					.addClass("dhtmlxcalendar_month_arrow_right")
					.addClass("cal_arrow_disabled")
					.hover(
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right cal_arrow_disabled"},0,this);},
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right cal_arrow_disabled"},0,this);}
					);
			} else {
				$(this.contMonth.firstChild.firstChild.lastChild)
					.removeClass("cal_arrow_disabled")
					.hover(
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right_hover"},0,this);},
						function(){setTimeout(function(t){t.className="dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right"},0,this);}
					);
			}
		}
	}
	return true;
}

/**
 * 年セレクタの機能補正を行う。
 * @method patchUpdateYearsList
 * @param a 選択中の年
 */
BlenderCalendarObject.patchUpdateYearsList = function(a) {
	// 不具合：選択可能範囲を超えて年を選択可能な点を改善
	if (this._rangeType == "in") {
		var minYear = null, maxYear = null;
		if (this._rangeFrom)	minYear = new Date(this._rangeFrom).getFullYear();
		if (this._rangeTo)		maxYear = new Date(this._rangeTo).getFullYear();
		var disableL = false, disableR = false;
		for(var c=12*Math.floor(a.getFullYear()/12),d=0;d<4;d++) {
			for(var e=0;e<3;e++) {
				var theYear = this.ysCont.childNodes[d].childNodes[e]._year;
				if (minYear && theYear <= minYear) {
					disableL = true;
				}
				if (maxYear && theYear >= maxYear) {
					disableR = true;
				}
				if (theYear < minYear || theYear > maxYear) {
					this.ysCont.childNodes[d].childNodes[e].innerHTML='<span style="color:#c0c0c0">'+theYear+'</span>';
				}
			}
		}

		// 左右の矢印セルの "onclick", "onmouseover", "onmouseout" 処理にパッチを当てる
		var patchTargets = [
			this._sel.firstChild.firstChild.firstChild.childNodes[0],
			this._sel.firstChild.firstChild.firstChild.childNodes[2]
		];
		var patchFuncs = [
			"onclick", "onmouseover", "onmouseout"
		];
		$.each(patchTargets, function(i, patchTarget){
			$.each(patchFuncs, function(j, patchFunc){
				// ハンドラに "cal_arrow_disabled" 指定がなければ（パッチ未実行なら）、パッチを行う
				if ((patchTarget[patchFunc] + "").indexOf("cal_arrow_disabled") == -1) {
					override(patchTarget, patchFunc, when(function(e) {
						// classに "cal_arrow_disabled" 指定があれば、スキップする
						return !$(this).hasClass("cal_arrow_disabled");
					}));
				}
			});
		});

		if (disableL) {
			$(this._sel.firstChild.firstChild.firstChild.childNodes[0]).addClass("cal_arrow_disabled");
		} else {
			$(this._sel.firstChild.firstChild.firstChild.childNodes[0]).removeClass("cal_arrow_disabled");
		}
		if (disableR) {
			$(this._sel.firstChild.firstChild.firstChild.childNodes[2]).addClass("cal_arrow_disabled");
		} else {
			$(this._sel.firstChild.firstChild.firstChild.childNodes[2]).removeClass("cal_arrow_disabled");
		}
	}
}

/**
 * 年、月表示位置入替の機能拡張を行う。
 * @method extendSwapYearMonthPos
 * @param calendar dhtmlxCalendarオブジェクト
 */
BlenderCalendarObject.extendSwapYearMonthPos = function(calendar) {

	// 年、月表示位置入替
	if (calendar.swapYearMonthPos) {
		var year = $(calendar.contMonth).find(".dhtmlxcalendar_month_label_year").first();
		year.css({"position": "absolute", "top": "0px", "left": "60px"});

		var month = $(calendar.contMonth).find(".dhtmlxcalendar_month_label_month").first();
		month.css({"position": "absolute", "top": "0px", "left": "110px"});

		var span = document.createElement("SPAN");
		span.className = "dhtmlxcalendar_month_label_year";
		span.innerHTML = BlenderCalendarObject.LABEL_YEAR;
		year.after(span);

	}

	// _showSelector()処理オーバーライド（前処理追加）
	override(calendar, "_showSelector", preprocess(function(a, b, c, d, e) {
		if (this.swapYearMonthPos) {
			// 年、月のポップアップ位置調整
			if (a == "year") {
				if(calendar.conf.skin=="blender_jquery") {
					b = 92;
				}
			} else if (a == "month") {
				if(calendar.conf.skin=="blender_jquery") {
					b = 132;
				}
			}
		}
		return [a, b, c, d, e];
	}));



}

/**
 * [OK]ボタン表示の機能拡張を行う。
 * @method extendUseOkButton
 * @param calendar dhtmlxCalendarオブジェクト
 */
BlenderCalendarObject.extendUseOkButton = function(calendar) {

	// 時刻表示部に、[OK]ボタンを追加
	if (calendar.useOkButton) {
		var button = document.createElement("BUTTON");
		button.className = "bl_calendar_ok_button";
		button.innerHTML = BlenderCalendarObject.LABEL_OK;
		$(calendar.contTime).append(button);

		var that = calendar;

		button.onclick = function(){
			if (calendar._activeDateCell == null) {
				return;
			}
			var e = new Object();
			e.target = that._activeDateCell;
			that.contDates.onclickOrig(e);
		};

		// 時刻表示ありの場合、日付クリックで閉じないよう、処理を差替
		that.contDates.onclickOrig = that.contDates.onclick;
		that.contDates.onclick=function(a){
			var isTimeVisible = $(that.base).hasClass("hastime");
			if (that.useOkButton && isTimeVisible) {
				that.blockClick = true;
			}
			var ret = this.onclickOrig(a);	// 本来処理を呼び出す
			that.blockClick = false;
			return ret;
		};
	}

	// attachEvent()処理オーバーライド（前処理追加）
	override(calendar, "attachEvent", preprocess(function(a, b) {
		if (String(a).toLowerCase() == "onclick") {
			var original = b;
			b = function() {
				// 時刻表示ありの場合、日付クリックで閉じないようブロック
				if (this.blockClick) {
					return;
				}
				original.apply(this);
			}
		}
		return [a, b];
	}));

	// show()処理オーバーライド（前処理追加）
	override(calendar, "show", before(function(id) {
		var isTimeVisible = $(this.base).hasClass("hastime");
		if (this.useOkButton && isTimeVisible) {
			$(this.contTime).find(".dhtmlxcalendar_time_label, .bl_calendar_ok_button").show();
		} else {
			$(this.contTime).find(".dhtmlxcalendar_time_label, .bl_calendar_ok_button").hide();
		}
	}));

	// hide()処理オーバーライド（実行条件追加）
	override(calendar, "hide", when(function() {
		// 時刻表示ありの場合、日付クリックで閉じないようブロック
		if (this.blockClick) {
			return false;
		}
		return true;
	}));
}

/**
 * 分の拡張モード追加の機能拡張を行う。
 * @method extendUseFlexMinutesInterval
 * @param calendar dhtmlxCalendarオブジェクト
 */
BlenderCalendarObject.extendUseFlexMinutesInterval = function(calendar) {

	// setMinutesInterval()処理オーバーライド（前処理追加）
	override(calendar, "setMinutesInterval", before(function(d, internal) {
		if (!internal) {
			this._minutesIntervalOrig = d;	// 設定値を反映
		}
	}));

	// 設定値を初期化
	calendar._minutesIntervalOrig = calendar._minutesInterval;

	// _showSelector()処理オーバーライド（後処理追加）
	override(calendar, "_showSelector", after(function(a,b,c,d,e) {
		if (this.useFlexMinutesInterval) {
			// セレクタを確定せずに閉じた場合に、本来の分単位に戻るよう対処
			if (a == "minutes") {
				if (this._selectorMode == 1) {
					this._minutesIntervalRevert = null;
				} else if (this._selectorMode == 2) {
					// hide時に本来のモードに戻すよう予約
					this._minutesIntervalRevert = this._minutesIntervalOrig;
				}
			}
		}
	}));

	// _initSelector()処理オーバーライド（後処理追加）
	override(calendar, "_initSelector", after(function(a,d) {
		if (this.useFlexMinutesInterval) {
			// 5分単位モードの場合、[...]ボタンを追加
			if (a == "minutes" && this._minutesInterval == 5) {
				var ul = this.rsCont.lastChild;
				if (ul.lastChild.innerHTML != BlenderCalendarObject.LABEL_EXPAND) {
					ul.style.width = "95px";	// 親のULの幅を81px→95pxに拡張
					var li = document.createElement("LI");
					li.innerHTML = BlenderCalendarObject.LABEL_EXPAND;
					li.className = "dhtmlxcalendar_selector_cell";
					li.style.width = "14px";

					var that = calendar;

					// [...]ボタンクリック時の処理
					li.onclick = function() {
						// 一旦ポップアップを消去し、1分単位モードで開き直す
						calendar._hideSelector(true);
						calendar.setMinutesInterval(1, true);
						that._selectorMode = 1;
						that._showSelector("minutes", 59, 149, "selector_minutes", true, true);

						// 分表示部の10の位を選択表示に変更
						var t = that._fixLength(that._activeDate.getMinutes(),2).toString();
						t = "<span class='dhtmlxcalendar_selected_date'>"+t.charAt(0)+"</span>"+t.charAt(1);
						that.contTime.firstChild.firstChild.childNodes[3].innerHTML = t;

						return true;
					};
					ul.appendChild(li);
				}
			}
		}
	}));

	// _hideSelector()処理オーバーライド（後処理追加）
	override(calendar, "_hideSelector", after(function() {
		if (this.useFlexMinutesInterval) {
			// [...]による1分単位モードから、本来のモードに復元
			if (this._minutesIntervalRevert) {
				this._minutesInterval = this._minutesIntervalRevert;
				this._minutesIntervalRevert = null;
			}
		}
	}));
}

/**
 * 分の拡張モード追加の機能拡張を行う。
 * @method extendUseFlexMinutesInterval
 * @param calendar dhtmlxCalendarオブジェクト
 */
BlenderCalendarObject.extendSelectionStyle = function(calendar) {

	if (!calendar.useSelectionStyle) return;

	var zIndex = dhx4.zim.reserve() + 100;
	//
	calendar.calendarDiv = $("<div id='bl_calendarDiv' "+
			"style='position:absolute;left:0px;top:0px;display:none;z-index:"+zIndex+"'>"+
			"</div>");
	$(calendar.base).parent().prepend(calendar.calendarDiv);
	//
	calendar.dropdownYear =  $("<div id='bl_calendarYear' style='position:absolute;z-index:"+zIndex+";left:60px;top:6px;'></div>");
	calendar.calendarDiv.append(calendar.dropdownYear);
	$(calendar.calendarDiv).find("#bl_calendarYear").on('click',function(e){
		e.stopPropagation();
	});
	$(calendar.calendarDiv).find("#bl_calendarYear").change(function (val) {
		var tYear = $(this).find(":selected").val();
		calendar._drawMonth(new Date(tYear, calendar._activeMonth.getMonth(), 1, 0, 0, 0, 0));
		calendar._doOnSelectorChange();
	})
	var richSelectorSelect = "<select class='dhtmlxcalendar_label_year'>";
	richSelectorSelect += "</select>";
	calendar.dropdownYear.append($(richSelectorSelect));
	//
	calendar.dropdownMonth =  $("<div id='bl_calendarMonth' style='position:absolute;z-index:"+zIndex+";left:120px;top:6px;'></div>");
	calendar.calendarDiv.append(calendar.dropdownMonth);
	$(calendar.calendarDiv).find("#bl_calendarMonth").on('click',function(e){
		e.stopPropagation();
	});
	$(calendar.calendarDiv).find("#bl_calendarMonth").change(function (val) {
		var tMonth = $(this).find(":selected").val();
		calendar._drawMonth(new Date(calendar._activeMonth.getFullYear(), tMonth-1, 1, 0, 0, 0, 0));
		calendar._doOnSelectorChange();
	});
	var richSelectorSelect = "<select class='dhtmlxcalendar_label_month'>";
	for( var month=1; month<=12; month++ ) {
		richSelectorSelect += "<option value='"+month+"'>"+month+"月</option>";
	}
	richSelectorSelect += "</select>";
	calendar.dropdownMonth.append($(richSelectorSelect));
	//
	calendar.dropdownHour =  $("<div id='bl_calendarHour' style='position:absolute;z-index:"+zIndex+";left:66px;top:182px;'></div>");
	calendar.calendarDiv.append(calendar.dropdownHour);
	$(calendar.calendarDiv).find("#bl_calendarHour").on('click',function(e){
		e.stopPropagation();
	});
	$(calendar.calendarDiv).find("#bl_calendarHour").change(function (val) {
		var tHour = $(this).find(":selected").val();
		calendar._activeDate.setHours(tHour);
	});
	var richSelectorSelect = "<select class='dhtmlxcalendar_label_hour'>";
	for( var hour=0; hour<=23; hour++ ) {
		var hourL = (hour<10) ? "0"+hour : hour;
		richSelectorSelect += "<option value='"+hour+"'>"+hourL+"</option>";
	}
	richSelectorSelect += "</select>";
	calendar.dropdownHour.append($(richSelectorSelect));
	//
	calendar.dropdownMinute =  $("<div id='bl_calendarMinute' style='position:absolute;z-index:"+zIndex+";left:112px;top:182px;'></div>");
	calendar.calendarDiv.append(calendar.dropdownMinute);
	$(calendar.calendarDiv).find("#bl_calendarMinute").on('click',function(e){
		e.stopPropagation();
	});
	$(calendar.calendarDiv).find("#bl_calendarMinute").change(function (val) {
		var tMinute = $(this).find(":selected").val();
		calendar._activeDate.setMinutes(tMinute);
	});
	var richSelectorSelect = "<select class='dhtmlxcalendar_label_minute'>";
	for( var minute=0; minute<=59; minute++ ) {
		var minuteL = (minute<10) ? "0"+minute : minute;
		richSelectorSelect += "<option value='"+minute+"'>"+minuteL+"</option>";
	}
	richSelectorSelect += "</select>";
	calendar.dropdownMinute.append($(richSelectorSelect));
	//
	calendar._orgBuildMonthHdr = dhtmlXCalendarObject.prototype._buildMonthHdr;
	calendar._buildMonthHdr = function(val) {
		var that = this;
		var z = function(t) {
			return (String(t).length==1?"0"+String(t):t);
		}
		var w = function(type, str) {
			var rLabel = "";//"<span class='dhtmlxcalendar_month_label_"+type+"'>"+str+"</span>";
			//
			if(type=="year") {
				$(calendar.calendarDiv).find(".dhtmlxcalendar_label_year").empty();
				var sYear = 2000;
				if(calendar._rangeFrom!=null) sYear = new Date(calendar._rangeFrom).getFullYear();
				var eYear = 2100;
				if(calendar._toFrom!=null) eYear = new Date(calendar._rangeTo).getFullYear();
				var rOption = "";
				for( var year=sYear; year<=eYear; year++ ) {
					if(val.getFullYear()==year) {
						rOption += "<option value='"+year+"' selected>"+year+"</option>";
					} else {
						rOption += "<option value='"+year+"'>"+year+"</option>";
					}
				}
				$(calendar.calendarDiv).find(".dhtmlxcalendar_label_year").append(rOption);
			} else {
				var tMonth = (val.getMonth()+1);
				$(calendar.calendarDiv).find(".dhtmlxcalendar_label_month").val(tMonth);
				//
				var tHour = calendar._activeDate.getHours();
				$(calendar.calendarDiv).find(".dhtmlxcalendar_label_hour").val(tHour);
				var tMinute = calendar._activeDate.getMinutes();
				$(calendar.calendarDiv).find(".dhtmlxcalendar_label_minute").val(tMinute);
				//
				if(calendar.conf.time) {
					var mTop = calendar.contMonth.offsetHeight+calendar.contDays.offsetHeight+calendar.contDates.offsetHeight;
					$(calendar.calendarDiv).find("#bl_calendarHour").css("visibility", "visible");
					$(calendar.calendarDiv).find("#bl_calendarMinute").css("visibility", "visible");
				} else {
					$(calendar.calendarDiv).find("#bl_calendarHour").css("visibility", "hidden");
					$(calendar.calendarDiv).find("#bl_calendarMinute").css("visibility", "hidden");
				}
			}
			return rLabel;
		}
		var format = String(calendar.langData[calendar.lang].hdrformat||("%F %Y")).replace(/%[a-z]/gi, function(t){
			switch (t) {
				case "%m": return w("month", z(val.getMonth()+1));
				case "%n": return w("month", val.getMonth()+1);
				case "%M": return w("month", that.langData[that.lang].monthesSNames[val.getMonth()]);
				case "%F": return w("month", that.langData[that.lang].monthesFNames[val.getMonth()]);
				case "%y": return w("year", z(val.getYear()%100));
				case "%Y": return w("year", val.getFullYear());
				case "%%": return "%";
				default: return t;
			}
		});
		that = z = w = null;
		return format;
	};

	override(calendar, "_show", after(function() {
		//
		$(calendar.calendarDiv).css("left", $(calendar.base).css("left"));
		$(calendar.calendarDiv).css("top", $(calendar.base).css("top"));
		calendar.calendarDiv.show();
	}));
	override(calendar, "_hide", after(function() {
		calendar.calendarDiv.hide();
	}));
}

/*
Copyright MITSUBISHI Elec.
*/
